/** Plantillas de texto pre-configuradas. Aplicar = sobrescribir estilos
 *  del overlay manteniendo `text`, `start`, `end`, `id`. */

import type { TextOverlay } from "../api/projects";

export interface TextPreset {
  id: string;
  label: string;
  desc: string;
  swatch?: string;     // muestra visual (mini ejemplo)
  apply: () => Partial<TextOverlay>;
}

export const TEXT_PRESETS: TextPreset[] = [
  {
    id: "classic",
    label: "Subtítulo clásico",
    desc: "Caja negra · texto blanco bold",
    swatch: "Hola",
    apply: () => ({
      font_size: 60, color: "#ffffff", bold: true,
      align: "center", background: "rgba(0,0,0,0.7)", padding: 14,
      x: 0.5, y: 0.85,
      fade_in_ms: 200, fade_out_ms: 200,
      animation_in: "fade", animation_out: "fade",
    }),
  },
  {
    id: "beast",
    label: "Beast (impacto)",
    desc: "Letras enormes blancas sin fondo (estilo TikTok)",
    swatch: "WOW",
    apply: () => ({
      font_size: 110, color: "#ffffff", bold: true,
      align: "center", background: null, padding: 0,
      x: 0.5, y: 0.5,
      fade_in_ms: 100, fade_out_ms: 100,
      animation_in: "pop", animation_out: "fade",
    }),
  },
  {
    id: "headline",
    label: "Titular cinemático",
    desc: "Centrado grande sin fondo · fade lento",
    swatch: "Aa",
    apply: () => ({
      font_size: 120, color: "#ffffff", bold: true,
      align: "center", background: null, padding: 0,
      x: 0.5, y: 0.45,
      fade_in_ms: 600, fade_out_ms: 600,
      animation_in: "fade", animation_out: "fade",
    }),
  },
  {
    id: "lower_third",
    label: "Lower third (TV)",
    desc: "Barra de color en la parte inferior · desliza desde izquierda",
    swatch: "▬",
    apply: () => ({
      font_size: 48, color: "#ffffff", bold: true,
      align: "left", background: "rgba(20,80,200,0.92)", padding: 22,
      x: 0.05, y: 0.82,
      fade_in_ms: 350, fade_out_ms: 250,
      animation_in: "slide-left", animation_out: "slide-left",
    }),
  },
  {
    id: "quote",
    label: "Cita",
    desc: "Texto centrado grande con caja oscura",
    swatch: "«»",
    apply: () => ({
      font_size: 64, color: "#ffffff", bold: false,
      align: "center", background: "rgba(0,0,0,0.82)", padding: 24,
      x: 0.5, y: 0.5,
      fade_in_ms: 400, fade_out_ms: 400,
      animation_in: "zoom", animation_out: "fade",
    }),
  },
  {
    id: "watermark",
    label: "Marca de agua",
    desc: "Pequeño en esquina inferior derecha",
    swatch: "@",
    apply: () => ({
      font_size: 28, color: "#ffffff", bold: false,
      align: "right", background: "rgba(0,0,0,0.4)", padding: 8,
      x: 0.97, y: 0.95,
      fade_in_ms: 100, fade_out_ms: 100,
      animation_in: "fade", animation_out: "fade",
    }),
  },
  {
    id: "typewriter",
    label: "Máquina de escribir",
    desc: "Letras apareciendo una a una",
    swatch: "...",
    apply: () => ({
      font_size: 70, color: "#ffffff", bold: true,
      align: "center", background: "rgba(0,0,0,0.6)", padding: 14,
      x: 0.5, y: 0.5,
      fade_in_ms: 1200, fade_out_ms: 300,
      animation_in: "typewriter", animation_out: "fade",
    }),
  },
];

export const ANIMATION_OPTIONS: { id: TextOverlay["animation_in"]; label: string }[] = [
  { id: "none",         label: "Sin animación" },
  { id: "fade",         label: "Fundido" },
  { id: "slide-left",   label: "Desliza desde izquierda" },
  { id: "slide-right",  label: "Desliza desde derecha" },
  { id: "slide-up",     label: "Desliza desde abajo" },
  { id: "slide-down",   label: "Desliza desde arriba" },
  { id: "zoom",         label: "Zoom (crece)" },
  { id: "pop",          label: "Pop (rebote)" },
  { id: "typewriter",   label: "Máquina de escribir" },
];
